import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { DATA_SOURCES_TEST_PREFIX } from "../Utils";
import { Checkbox, TextArea } from "@theorgchartdev/storybook";
import { appcstr } from "@coreapp/utils/appcstr";
export const PeopleHRSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const { query, queryName, queryAll } = config;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    >
      <Checkbox
        id={"toggle-query"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-peoplehr-query-checkbox`}
        label={appcstr("peopleHR7")}
        size={"medium"}
        checked={query}
        onChange={() => onChange({ ...config, query: !query })}
      />
      {query && (
        <TextArea
          dataTestId={`${DATA_SOURCES_TEST_PREFIX}-peoplehr-query-name-textarea`}
          inputOnly
          size="medium"
          value={queryName}
          placeholder={""}
          onChange={event => onChange({ ...config, queryName: event.target.value })}
        />
      )}
      <Checkbox
        id={"toggle-queryall"}
        data-testid={`${DATA_SOURCES_TEST_PREFIX}-peoplehr-query-all-checkbox`}
        label={appcstr("peopleHR8")}
        size={"medium"}
        checked={queryAll}
        onChange={() => onChange({ ...config, queryAll: !queryAll })}
      />
    </DataSourceSetupComposite>
  );
};
